var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from 'react';
import { Requester } from '@frontend-components/utils/requester';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { setPurchaseSidebarOpen } from '../../slices/sidebarSlice';
import { useLazyGetBasketQuery } from '../../api/basket';
import PurchaseSidebarFeature, { BasketChangeEvents } from '@frontend-components/features/PurchaseSidebar';
import { getGlobalState, getPaymentServiceUrl } from '../../../Utils/GlobalState';
const PurchaseSidebar = () => {
    const dispatch = useDispatch();
    const [user, setUser] = useState();
    const [priceSet, setPriceSet] = useState();
    const [recommendedProducts, setRecommendedProducts] = useState();
    const [basketPartnerText, setBasketPartnerText] = useState();
    const [isBasketUpdateLoading, setBasketUpdateLoading] = useState(false);
    const applicationUrl = getGlobalState('application_url');
    const paymentUrl = getPaymentServiceUrl();
    const [getBasket, { data: basketData, isLoading: isBasketLoading, isFetching: isBasketFetching }] = useLazyGetBasketQuery({ refetchOnFocus: true });
    const { isOpen } = useSelector((state) => ({ isOpen: state.sidebar.isOpen }), shallowEqual);
    useEffect(() => {
        fetchUser();
        fetchBasket();
        fetchRecommendedProducts();
        fetchBasketPartnerText();
    }, []);
    useEffect(() => {
        if (user != null) {
            fetchPricesSet(user, (data) => setPriceSet(data));
        }
    }, [user]);
    const filteredRecommendedProducts = useMemo(() => {
        if (recommendedProducts == null || basketData == null) {
            return [];
        }
        let products = [...recommendedProducts];
        basketData.items.forEach((item) => {
            if (recommendedProducts.includes(item.product)) {
                products = products.filter((product) => product != item.product);
            }
        });
        return products;
    }, [recommendedProducts, basketData]);
    const handleChangeBasket = (event, item) => __awaiter(void 0, void 0, void 0, function* () {
        const { product, purchase_type, id } = item;
        setBasketUpdateLoading(true);
        if (event === BasketChangeEvents.ADD) {
            if (product != null && purchase_type != null) {
                const requestBody = (user === null || user === void 0 ? void 0 : user.onboardingPartner) != null ? { product, purchase_type, partner: user.onboardingPartner.id } : { product, purchase_type };
                try {
                    yield Requester.post(`${applicationUrl}/api/basket`, requestBody);
                    fetchBasket();
                }
                finally {
                    setBasketUpdateLoading(false);
                }
            }
        }
        else if (event === BasketChangeEvents.EDIT) {
            if (id != null && purchase_type != null) {
                try {
                    yield Requester.put(`${applicationUrl}/api/basket/${id}`, { purchase_type });
                    fetchBasket();
                }
                finally {
                    setBasketUpdateLoading(false);
                }
            }
        }
        else if (event === BasketChangeEvents.DELETE) {
            if (id != null) {
                try {
                    yield Requester.delete(`${applicationUrl}/api/basket/${id}`);
                    fetchBasket();
                }
                finally {
                    setBasketUpdateLoading(false);
                }
            }
        }
    });
    if (user == null)
        return null;
    const isLoading = isBasketLoading || isBasketUpdateLoading || isBasketFetching;
    return (_jsx(PurchaseSidebarFeature, { serviceUrls: { applicationUrl, paymentUrl: getPaymentServiceUrl() }, user: user, onClose: () => dispatch(setPurchaseSidebarOpen(false)), open: isOpen, basket: basketData, priceSet: priceSet, recommendedProductsData: filteredRecommendedProducts, onGoToBasketClick: () => window.location.href = '/basket', onboardingPartnerText: basketPartnerText, onBasketChange: handleChangeBasket, isLoading: isLoading }));
    function fetchUser() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield Requester.get(`${applicationUrl}/api/user/details`, { withCredentials: true });
                setUser(data);
            }
            catch (_a) { }
        });
    }
    function fetchBasket() {
        return __awaiter(this, void 0, void 0, function* () {
            const applicationUrl = getGlobalState('application_url');
            getBasket(applicationUrl).unwrap();
        });
    }
    function fetchPricesSet(user, callback) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const partner = (_c = (_b = (_a = user === null || user === void 0 ? void 0 : user.partners) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null;
            try {
                const { data } = yield Requester.get(`${paymentUrl}/api/price-set${partner != null ? `?partner=${partner}` : ''}`);
                callback(data);
            }
            catch (_d) { }
        });
    }
    function fetchRecommendedProducts() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield Requester.get(`${applicationUrl}/api/score/recommended-products`);
                setRecommendedProducts(data);
            }
            catch (_a) { }
        });
    }
    function fetchBasketPartnerText() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield Requester.get(`${applicationUrl}/api/basket/partner-text`);
                setBasketPartnerText(data);
            }
            catch (_a) { }
        });
    }
};
export default PurchaseSidebar;
